class Configs {
  constructor(data) {
    this.name = data.key || null;
    this.label = data.key.replace('_', ' ').capitalize();
    this.options = data.possible_values || [];
    this.type = data.value_type.toLowerCase() || null;
    this.value = data.default_value;
    this.config = data.config_type;
    this.pk = data.pk;
    this.entityName = data.entity_name;
    this.extraData = data.extra_data;
    this.attributeName = data.attribute_name;
    this.config_master_light = data.config_master_light ?? true;
  }
}
export default Configs;